import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class GetHighRiskIdentityCards extends Http {
  [x: string]: any
  public async getHighRiskIdentityCards(data: NLoginApi.HighRiskIdentityCardRequestData) {
    return await super.request<NLoginApi.HighRiskIdentityCardResponse>({
      url: '/crossbowSystem/getHighRiskIdCard',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getHighRiskIdentityCardsExport(data: NLoginApi.HighRiskIdentityCardRequestData) {
    return await super.request<NLoginApi.HighRiskIdentityCardResponse>({
      url: '/crossbowSystem/exportIdCardExcel',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'blob',
      data
    })
  }
}

export default GetHighRiskIdentityCards
